import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {
    IDegreeDurationCreate,
    IDegreeDurationPayload
} from "../types";
import {
    deletedDegreeDuration, deletedRestoreDegreeDuration,
    setDegreeDuration, setRestoreDegreeDuration,
    updateDegreeDuration
} from "./degreeDurationSlice";



const GetDegreeDuration= createAsyncThunk(
    "get/maximum/courses",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/maximum-courses");
            dispatch(setDegreeDuration(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const SetDegreeDuration= createAsyncThunk(
    "create/maximum/courses",
    async ( data:IDegreeDurationCreate ,{rejectWithValue}) => {
        try {
            const response = await request.post("/maximum-courses", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditDegreeDuration= createAsyncThunk(
    "edit/maximum/courses",
    async ( data :IDegreeDurationPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/maximum-courses/${data.id}`, data);
            dispatch(updateDegreeDuration(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteDegreeDuration= createAsyncThunk(
    "delete/maximum/courses",
    async (id:number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/maximum-courses/${id}`);
            dispatch(deletedDegreeDuration(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteDegreeDuration= createAsyncThunk(
    "get/delete/maximum/courses",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/maximum-courses/deleted-items`);
            dispatch(setRestoreDegreeDuration(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



const RestoreDeleteDegreeDuration = createAsyncThunk(
    "restore/delete/maximum/courses",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/maximum-courses/restore/${id}`);
            dispatch(deletedRestoreDegreeDuration(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



export{
    GetDegreeDuration,
    SetDegreeDuration,
    EditDegreeDuration,
    DeleteDegreeDuration,
    GetDeleteDegreeDuration,
    RestoreDeleteDegreeDuration,
}